import { COMMON_LINK_COLOR, COMMON_TEXT_COLOR, COMMON_WHITE_FOREGROUND, GRAY_BG_COLOR } from "../constants";


export const mailHeaderLogo = {
    maxWidth: '150px',
    height: '100px',
    objectFit: 'contain'
}

export const headerTextStyle = {
    color: COMMON_TEXT_COLOR,
    fontSize: '28px',
    textAlign: 'center'
}

export const tableResetStyle = {
    WebkitTextSizeAdjust: '100%',
    msTextSizeAdjust: '100%',
    msoTableLspace: '0pt',
    msoTableRspace: '0pt',
    borderCollapse: 'collapse'
}

export const tableLayoutStyle = {
    backgroundColor: GRAY_BG_COLOR,
    width: '100%',
    maxWidth: '650px',
    padding: '30px',
    margin: '0px auto'
}

export const mailBody = {
    color: COMMON_TEXT_COLOR,
    fontFamily: 'Arial',
    fontSize: '16px',
    padding: '30px 0 30px'
}

export const mailButtonStyle = {
    padding: '10px 16px',
    textDecoration: 'none',
    borderRadius: '2px',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontWeight: 'normal',
    fontSize: '18px',
    whiteSpace: 'normal',
    backgroundColor: COMMON_TEXT_COLOR,
    color: COMMON_WHITE_FOREGROUND,
    display: 'inline-block'
}

export const linkText = {
    color: COMMON_LINK_COLOR,
    textDecoration: 'none',
    cursor: 'pointer',
    borderBottom: '1px solid #1852D8'
}

export const mailMainTitle = {
    paddingBottom: '25px',
    fontWeight: 'bold',
    fontSize: '40px',
    lineHeight: '48px',
    margin: '0',
    padding: '0',
    textAlign: 'center'
}

export const textCenter = {
    textAlign: 'center'
}

export const fontBold = {
    fontWeight: 'bold'
}

export const footerStyle = {
    color: '#9ca299',
    fontSize: '14px',
    textAlign: 'center',
};

export const spaceBottom = {
    marginBottom: '6px'
}

export const profilePic = {
    borderRadius: '50%',
    margin: '0',
    padding: '0',
    width: '70px',
}